const createRecoilAtomKeys = <Module extends string, StateProps extends string>(
  module: Module,
  properties: string[],
) =>
  ({
    [module]: properties.reduce(
      (acc, prop) => ({
        ...acc,
        [prop]: {
          atom: `${module}${prop.charAt(0).toUpperCase() + prop.slice(1)}`,
        },
      }),
      {},
    ),
  } as Record<Module, Record<StateProps, { atom: string }>>);

export default createRecoilAtomKeys;
